<template>
  <block>
    <slot></slot>
  </block>
</template>
<script>
export default {};
</script>
